import React, { useState, useRef } from 'react';

const services = [
  { title: 'Property', desc: 'Protect your property assets with comprehensive coverage.', image: '/image/property2.jpg'},
  { title: 'Motor Vehicle', desc: 'Coverage for all types of vehicles, personal or fleet.', image: '/image/vehicle3.jpg'},
  { title: 'Health', desc: 'Securing your goods in transit across sea and land.', image: '/image/health2.jpg'},
  { title: 'Energy', desc: 'Comprehensive health protection for you and your team.', image: '/image/energy2.jpg'},
  { title: 'Heavy Equipment', desc: 'Secure the future of those who matter most.', image: '/image/heavyequipment2.jpg'},
  { title: 'Liability', desc: 'Coverage for construction and engineering projects.', image: '/image/liability2.jpg'},
  { title: 'Marine', desc: 'Protecting your business from third-party claims.', image: '/image/marine2.jpg'},
  { title: 'Construction', desc: 'Specialized coverage for aviation risks and assets.', image: '/image/construction2.jpg'},
  { title: 'Travel', desc: 'Insurance tailored for heavy and specialized equipment.', image: '/image/travel2.jpg'},
];

// const IMAGE_URL = "https://www.acrisure.com/_next/image?url=https%3A%2F%2Fedge.sitecorecloud.io%2Facrisurellc1-acrisure-prod-0dbe%2Fmedia%2FProject%2FAcrisure%2FAcrisure-Site%2FMaster-Site%2FPages%2FWhy-Acrisure%2FPromo-full.png%3Fh%3D978%26iar%3D0%26w%3D1792&w=3840&q=75";

function Services() {
  const scrollRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const onMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const onMouseUp = () => setIsDragging(false);

  return (
    <section className="bg-gray-50 py-24 px-4">
      <div className="max-w-7xl mx-auto">




        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:gap-16 mb-12">
        
        {/* Left — big heading */}
        <div className="md:w-1/2">


            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-red-600 leading-tight">
            {/* <h2 className="text-4xl sm:text-5xl lg:text-6xl text-gray-400 leading-tight" style={{ fontFamily: 'BLMelodyMono', fontWeight: 600 }}> */}
                <span className="text-[#0e1e52]">Dedicated to helping our clients make</span> better insurance decisions{' '}
                <span className="text-[#0e1e52]">for a </span> better business{' '}
            </h2>

        </div>

        {/* Right — subtext */}
        <div className="md:w-1/2 mt-6 md:mt-0">
            <p className="text-[#0e1e52] text-lg leading-relaxed">
            We chose to focus on some specific insurance risks where our combined knowledge, 
            skills and experiences can give more added values to our clients
            </p>
        </div>

        </div>

        {/* Scrollable cards */}
        <div
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto pb-4 cursor-grab active:cursor-grabbing select-none"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          onMouseDown={onMouseDown}
          onMouseMove={onMouseMove}
          onMouseUp={onMouseUp}
          onMouseLeave={onMouseUp}
        >

            {services.map((service, i) => (
            <div
                key={i}
                className="flex-shrink-0 w-72 rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-md transition duration-300"
            >
                {/* Image with title inside */}
                <div className="h-64 overflow-hidden relative">
                <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover pointer-events-none"
                />
                {/* Gradient overlay */}
                <div 
                    className="absolute inset-0 opacity-30"
                    style={{ background: 'linear-gradient(135deg, #0e1e52)' }}
                />
                {/* Title on top of image */}
                <div className="absolute bottom-0 left-0 right-0 p-5">
                    <h3 
                    className="text-white text-lg uppercase"
                    style={{ fontFamily: 'BLMelodyMono', fontWeight: 700 }}
                    >
                    {service.title}
                    </h3>
                </div>
                </div>
            </div>
            ))}


        </div>

      </div>
    </section>
  );
}

export default Services;